import React from 'react';
import { connect } from 'react-redux';
import Form from '../../../components/form/form';
import Message from '../../../components/message/index';
import Breadcrumb from '../../../components/breadcrumb/index';
import { generalStatusReport, virtualNumberList, exportOmsgReport } from '../../../actions/actions';
import { scrollToTop } from '../../../actions/utils';
import Select from '../../../components/form/select';

class GeneralStatusReport extends React.Component {
    constructor(props)
    {
        super(props)
        this.reportRef = React.createRef();

        this.state = {
            itemDetailsToShow: [],
            list: [],
            pageNumber: 0,
            virtualNumberList: [],
            downloadOptions: {
                value: 'PDF',
                name: 'downloadOptions',
                type: 'select',
                label: '',
                placeholder: 'Dosya Tipi',
                options: [{name: 'PDF', value: 'pdf'},{name: 'Excel', value: 'xlsx'}],
                error: 'Lütfen dosya tipi seçiniz.',
                valid: true,
                touched: false,
                validationRules: {
                    isRequired: true
                }
            },
            formModel: {
                virtualNumber: {
                    value: '',
                    name: 'virtualNumber',
                    type: 'select',
                    label: 'Sanal Numara',
                    placeholder: 'Sanal Numara',
                    error: 'Lütfen Sanal Numara girin.',
                    options: [],
                    valid: false,
                    touched: false,
                    validationRules: {
                        isRequired: true
                    }
                },
            }
        };

        this.getVirtualNumberList();
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(data)
    {
        this.getReport(data);
    }

    getReport(data){
        var foundedObj = this.state.virtualNumberList.find(vm => vm.product.virtualNumber === data.virtualNumber).product;
        foundedObj.tariff = foundedObj.tariffName;
        this.props.dispatch(generalStatusReport({...data, ...foundedObj}, (response) => {
            this.setState({
                itemDetailsToShow: [],
                list: response.reportItems,
                pageNumber: response.pageNumber,
            });
        }, (data) => {
            scrollToTop();
        }));
    }

    downloadReport() {
        if(this.state.downloadOptions.value != '') {
            var foundedObj = this.state.virtualNumberList.find(vm => vm.product.virtualNumber === this.state.formModel.virtualNumber.value).product;
            foundedObj.tariff = foundedObj.tariffPlan;
            let requestData = {
                type: 'general',
                docType: this.state.downloadOptions.value,
                reportRequest: {
                    virtualNumber:this.state.formModel.virtualNumber.value,
                    pageNumber: this.state.pageNumber,
                    ...foundedObj
                }
            }
            this.props.dispatch(exportOmsgReport(requestData, () => {
            }, () => {
    
            }));
        }
    }

    getVirtualNumberList(){
        this.props.dispatch(virtualNumberList((response) => {
        }, (data) => {
            this.setState({
                virtualNumberList: data,
                formModel: {
                    ...this.state.formModel,
                    virtualNumber: {
                        ...this.state.formModel.virtualNumber,
                        options: data.map(x => ({value:x.product.virtualNumber, name:x.product.virtualNumber}))
                    }
                }
            })
        }));
    }

    async changePage(nextPageNumber){
        if(nextPageNumber === -1 && this.state.pageNumber === 0) {

        } else {
            this.getReport({virtualNumber:this.state.formModel.virtualNumber.value, pageNumber: nextPageNumber});
        }
    }

    handleSelectDownloadOption(data){
        if(data.target.value != '') {
            this.setState({downloadOptions: {...this.state.downloadOptions, value: data.target.value}})
        } else{
            this.setState({downloadOptions: {...this.state.downloadOptions, value: data.target.value}})
        }
    }

    render() {
        const breadcrumbItems = [{
            name: "Genel Durum"
        }];

        return (
        [
            <Breadcrumb items={breadcrumbItems} />,
            <section className="panel">
                <Message />
                <div className="container">
                    <div className="reports">
                        <div className="title-default">
                            <span>Genel Durum</span>
                        </div>
                        <div className="title-default small"><span></span></div>
                        <div className="title-default small">
                            <span>Sözleşme başlangıç ve bitiş tarihleri arasındaki genel gönderim durumu raporu</span>
                        </div>

                        <div className="report-form">
                            <Form model={this.state.formModel} handleSubmit={this.handleSubmit} smallTitle={""} buttonText={"Rapor Oluştur"} multipleColumn={true} buttonId={"report-list-filter"} />
                        </div>  
                        {this.state.list.length > 0 && 
                        <div>
                               <div style={{display: 'table', textAlign:'center', width: '100%', margin:'10px 0 10px 0'}}>
                            <div style={{display:'table-cell', width:'50vh', verticalAlign:'middle', paddingRight:'5px'}}>
                            <Select data={this.state.downloadOptions} handleChange={this.handleSelectDownloadOption.bind(this)} />

                            </div>
                            <div style={{display:'table-cell', width:'50vh', paddingLeft:'5px'}}>
                            <a id="report-send-download" className="btn primary" href="javascript:void(0)" title="Tümünü indir" onClick={this.downloadReport.bind(this)}>
                                                    <span>Tümünü indir</span>
                                                </a>
                            </div>
                        </div>
                                <div className="report-items">
                                    <div ref={this.reportRef} className="head custom-report-head">
                                        <div className="item custom-report-item">
                                            <div>Sanal Numara</div>
                                            <div>Tarife Adı</div>
                                            <div>Sözleşmedeki Mesaj Adedi</div>
                                            <div>Kalan Mesaj Adedi</div>
                                            <div>Başarılı Gönderilen Mesaj Sayısı</div>
                                        </div>
                                    </div>
                                    <div className="body">
                                        {this.state.list.map((item, i) =>
                                            <div className="item custom-report-item">
                                                <div>
                                                    <span className="label">Sanal Numara</span>
                                                    <span>{item.companyMsisdn}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Tarife Adı</span>
                                                    <span>{item.tariff}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Sözleşmedeki Mesaj Adedi</span>
                                                    <span>{item.contractCount}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Kalan Mesaj Adedi</span>
                                                    <span>{item.remainingContractCount}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Başarılı Gönderilen Mesaj Sayısı</span>
                                                    <span>{item.smsTotal}</span>
                                                </div>
                                            </div>
                                            )}
                                    </div>
                                </div>
                          
                        </div>
                          }
                          {this.state.list.length > 0 &&
                            <div className="paging">
                                {this.state.pageNumber !== 0 && <a href="javascript:void(0)" className={"first-item"} onClick={() => this.changePage(-1)}>&lt;&lt;</a>}
                                <a href="javascript:void(0)" className={"last-item"}  onClick={() => this.changePage(+1)}>&gt;&gt;</a>
                            </div>
                          }
                    </div>
                </div>
            </section>
        ]
      );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app 
    }
}


export default connect(mapStateToProps)(GeneralStatusReport)